"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _default2 = _interopRequireDefault(require("./default"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var local = _lodash.default.cloneDeep(_default2.default);
/*
const authConfig = {
  ...local.auth,
  useCookies: true,
  silentCallbackPath: 'http://localhost:3000/silent-callback',
  callbackPath: 'http://localhost:3001/login/callback',
  logoutPath: 'http://localhost:3001/login/logout',
};

local.auth = authConfig;
*/


var _default = local;
exports.default = _default;